import { Link } from "react-router-dom";
import { Carousel } from 'react-bootstrap';


import img1 from "../../../Assets/slider_Online/slider_online_1.jpg"
import img2 from "../../../Assets/slider_Online/slider_online_2.webp"
import img3 from "../../../Assets/slider_Online/slider_online_3.jpg"
import img4 from "../../../Assets/slider_Online/slider_online_4.jpg"
import img5 from "../../../Assets/slider_Online/slider_online_5.webp"
import img6 from "../../../Assets/slider_Online/slider_online_6.jpg"
import img7 from "../../../Assets/slider_Online/slider_online_7.jpg"


import style from "./homeOnline.module.css"


export default function HomeOnline(){


   const advertsOnlineSystem = [
      {image:img1} ,
      {image:img2} ,
      {image:img3} ,
      {image:img4} ,
      {image:img5} ,
      {image:img6} ,
      {image:img7} ,
   ]

   return (
      <>
         <div className="container-fluid p-4 mt-5">
            <div className="row">
               <div className="col-md-6">
                  <h1 className="text-center">Online System TREND</h1>
               </div>
               <div className="col-md-6">
                  <div className="text-center">
                     <Link to="login" className=" btn bg-main w-75 mb-2 p-1">Login Online System</Link>
                  </div>
               </div>
            </div>


            <div className="row">
               <div className={`${style.slider}`}>
                  <Carousel indicators={false} controls={true} interval={2000} >
                     {advertsOnlineSystem.map((ele , index) => (
                        <Carousel.Item key={index} className='carousel-item'>
                           <div className={`text-center carousel-div ${style.slide}`}>
                              <img src={ele.image} alt="cover" className={`${style.slide_img}`}/>
                           </div>
                        </Carousel.Item>
                     ))}
                  </Carousel>
               </div>
            </div>
         </div>
      </>
   )
}